import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IDataTableAdapter, IPagination, IRetailer } from '@app/shared/interfaces';
import { ToastrService } from 'ngx-toastr';
import { ManageRetailerDialogComponent } from '../../components/manage-retailer-dialog/manage-retailer-dialog.component';
import { RetailersService } from '@app/tvf/retailers/services/retailers/retailers.service';

@Component({
  selector: 'app-retailer',
  templateUrl: './retailer.component.html',
  styleUrls: ['./retailer.component.sass'],
})
export class RetailerComponent implements OnInit {
  pagination: IPagination = {
    totalItems: 0,
    pageSize: 10,
    currentPage: 1,
  };
  searchField = '';
  dataAdapter: IDataTableAdapter;
  inputModel: string;
  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    private retailersService: RetailersService
  ) {}

  ngOnInit(): void {
    this.getRetailerList();
  }

  getRetailerList() {
    this.dataAdapter = {
      columns: [
        { key: 'fantasyName', label: 'Nome do varejista', show: true },
        { key: 'retailerId', label: 'ID', show: true },
        { key: 'flowTypeDescription', label: 'Tipo de combo', show: true },
        { key: 'existsTrade', label: 'Status', show: true },
        { key: 'comissao', label: 'Comissão', show: true },
      ],
      enableAction: true,
      enablePagination: true,
      dataSource: [],
      pagination: this.pagination,
    };

    this.retailersService
      .getRetailers(this.pagination.currentPage, this.pagination.pageSize, this.searchField)
      .subscribe({
        next: (response: any) => {
          this.dataAdapter = {
            ...this.dataAdapter,
            dataSource: response.retailers,
            pagination: response.pagination,
          };
          this.pagination = response.pagination;
        },
        error: (err) => {
          this.toastr.error(err.errors);
        },
      });
  }

  openNewRetailerDialog() {
    const dialogRef: any = this.dialog.open(ManageRetailerDialogComponent, {
      minWidth: '50%',
      maxWidth: '90%',
      height: 'auto',
      panelClass: 'no-padding-dialog',
      data: { action: 'create' },
    });

    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result && result.up) {
          this.ngOnInit();
        }
      },
      error: (error) => {
        console.error('Error while closing dialog:', error);
      },
    });
  }

  paginationAction(event: { currentPage: number; pageSize: number }) {
    const { currentPage, pageSize } = event;

    this.pagination = {
      currentPage: currentPage,
      pageSize: pageSize,
    };

    this.ngOnInit();
  }
}
